var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "databases-and-servers/servers/graphql") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "databases-and-servers/servers/graphql",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#640B47",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "GraphQL_Logo",
    transform: "translate(13.000000, 11.000000)",
    fill: "#E535AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(13.900383, 20.558713) rotate(-149.999272) translate(-13.900383, -20.558713) ",
    x: 12.8053154,
    y: -0.570816834,
    width: 2.19013547,
    height: 42.2590597
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 1.95269386,
    y: 35.3859793,
    width: 42.2599894,
    height: 2.19018365
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(13.905410, 41.770219) rotate(-149.999272) translate(-13.905410, -41.770219) ",
    x: 1.70134192,
    y: 40.6751517,
    width: 24.4081362,
    height: 2.19013547
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(32.267910, 9.962552) rotate(-149.999272) translate(-32.267910, -9.962552) ",
    x: 20.0638417,
    y: 8.86748398,
    width: 24.4081362,
    height: 2.19013547
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(13.911268, 9.954213) rotate(-120.000728) translate(-13.911268, -9.954213) ",
    x: 12.8162004,
    y: -2.24985494,
    width: 2.19013547,
    height: 24.4081362
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(32.282938, 20.559109) rotate(-120.000728) translate(-32.282938, -20.559109) ",
    x: 11.1534078,
    y: 19.4640411,
    width: 42.2590597,
    height: 2.19013547
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 3.62831629,
    y: 13.6556631,
    width: 2.19018365,
    height: 24.4086732
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 40.3600711,
    y: 13.6556631,
    width: 2.19018365,
    height: 24.4086732
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(32.267817, 41.758042) rotate(-120.000728) translate(-32.267817, -41.758042) ",
    x: 31.3112824,
    y: 31.1438007,
    width: 1.91307014,
    height: 21.2284817
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4529077,38.7768058 C44.1862955,40.9801833 41.3628057,41.7322343 39.1594282,40.4656221 C36.9560507,39.1990098 36.2039997,36.3755201 37.4706119,34.1721425 C38.7372241,31.968765 41.5607139,31.216714 43.7640914,32.4833262 C45.9806628,33.7631323 46.7327139,36.5734282 45.4529077,38.7768058",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69476523,17.547857 C7.42815299,19.7512345 4.60466322,20.5032855 2.40128569,19.2366733 C0.197908161,17.9700611 -0.554142852,15.1465713 0.712469381,12.9431938 C1.97908161,10.7398162 4.80257138,9.98776521 7.00594891,11.2543774 C9.20932645,12.5341836 9.96137746,15.3444794 8.69476523,17.547857",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.725663259,38.7768058 C-0.540948975,36.5734282 0.211102039,33.7631323 2.41447957,32.4833262 C4.6178571,31.216714 7.42815299,31.968765 8.7079591,34.1721425 C9.97457134,36.3755201 9.22252032,39.185816 7.01914279,40.4656221 C4.80257138,41.7322343 1.99227549,40.9801833 0.725663259,38.7768058",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4838058,17.547857 C36.2171935,15.3444794 36.9692446,12.5341836 39.1726221,11.2543774 C41.3759996,9.98776521 44.1862955,10.7398162 45.4661016,12.9431938 C46.7327139,15.1465713 45.9806628,17.9568672 43.7772853,19.2366733 C41.5739078,20.5032855 38.750418,19.7512345 37.4838058,17.547857",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0892855,51.6936118 C20.5428672,51.6936118 18.4846223,49.6353669 18.4846223,47.0889485 C18.4846223,44.5425302 20.5428672,42.4842853 23.0892855,42.4842853 C25.6357038,42.4842853 27.6939487,44.5425302 27.6939487,47.0889485 C27.6939487,49.622173 25.6357038,51.6936118 23.0892855,51.6936118",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0892855,9.2357142 C20.5428672,9.2357142 18.4846223,7.17746932 18.4846223,4.63105098 C18.4846223,2.08463263 20.5428672,0.0263877549 23.0892855,0.0263877549 C25.6357038,0.0263877549 27.6939487,2.08463263 27.6939487,4.63105098 C27.6939487,7.17746932 25.6357038,9.2357142 23.0892855,9.2357142",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.bc3b14b31147a1ca27b986cc57259628.svg";
export { ForwardRef as ReactComponent };